import { get, post } from "@/utils/request";

/**
 * @description 公共接口地址
 */

export default {
  /**
   * @description 获取每个页面的头部图片
   * @param {*} params
   * @param {Object} belong 所属1小程序端，2网页端
   * @param {Object} picType 图片类型 首页banner indexBanner 用户登入userLogin用户注册 userRegister关于我们 aboutUs园区咨询 parkZx人才服务 recruit访客预约 visitor园区招商 investment平台介绍 platformMemo
   */
  getPic(params) {
    return post(`/wechat/tourist/getPic`, params);
  },

  /**
   * @description 获取每个页面的园区列表
   * @param {*} tenantName
   */
  getTenantList(tenantName) {
    return get(`/wechat/tourist/getTenantList?tenantName=${tenantName}`);
  },

  /**
   * @description 获取每个页面的资讯列表
   * @param {*} params
   */
  getPageList(params) {
    return post(`/wechat/tourist/newsPageList`, params);
  },

  /**
   * @description 获取每个页面的咨询类型列表
   * @param {*} params
   */
  getTypeList(params) {
    return post(`/wechat/tourist/newTypeList`, params);
  },

  /**
   * @description 获取企业列表 或 公司
   * @param {*} params 参数 {}
   */
  getCompanyList(params) {
    return post(`/wechat/tourist/getCompanyList`, params);
  },
};
